import { PolicyRequest } from '../policy-create';
import { PolicySearchResponse } from '../policy-search';
import { Dependent } from '../quote';

export const POLICY_INFO = 'POLICY_INFO';
export const POLICY_INFO_SUCCESS = 'POLICY_INFO_SUCCESS';
export const POLICY_INFO_FAILED = 'POLICY_INFO_FAILED';
export const POLICY_INFO_EXPIRED = 'POLICY_INFO_EXPIRED';
export const POLICY_INFO_SELECT = 'POLICY_INFO_SELECT';
export const POLICY_INFO_NAV_PAGE = 'POLICY_INFO_NAV_PAGE';
export const POLICY_INFO_EDIT = 'POLICY_INFO_EDIT';
export const POLICY_EDIT_ERRORS = 'POLICY_EDIT_ERRORS';
export const POLICY_EDIT_VALUES = 'POLICY_EDIT_VALUES';
export const POLICY_RESEND_STARTED = 'POLICY_RESEND_STARTED';
export const POLICY_RESEND_SUCCESS = 'POLICY_RESEND_SUCCESS';
export const POLICY_RESEND_FAILED = 'POLICY_RESEND_FAILED';
export const ACTIVE_ACCORDION = 'ACTIVE_ACCORDION';
export const POLICY_INITIAL_VALUES = 'POLICY_INITIAL_VALUES';
export const POLICY_INFO_UNSET = 'POLICY_INFO_UNSET';
export const POLICY_PREMIUM_CHANGED = 'POLICY_PREMIUM_CHANGED';
export const POLICY_LAYOVER_REDIRECT = 'POLICY_LAYOVER_REDIRECT';

export const DEPENDENT_INITIAL_VALUES = 'DEPENDENT_INITIAL_VALUES';
export const DEPENDENT_EDIT_ERRORS = 'DEPENDENT_EDIT_ERRORS';
export const DEPENDENT_EDIT_VALUES = 'DEPENDENT_EDIT_VALUES';
export const DEPENDENT_RESET_VALUES = 'DEPENDENT_RESET_VALUES';
export const REMOVE_DEPENDENT = 'REMOVE_DEPENDENT';

export interface PolicyResendRequest {
  policyNumbers: string[];
  ccEmails?: string;
  bccEmails?: string;
}
export interface PolicyInfoList {
  data?: PolicySearchResponse;
  selectedPolicies?: PolicyRequest[];
  searchFetched?: boolean;
  searchError?: unknown;
  searchExpired?: boolean;
  premiumChanged?: boolean;
  layoverRedirect?: boolean;
  resendPending?: boolean;
  resendDone?: boolean;
  resendError?: unknown;
  editPolicies?: boolean;
  deltaChanges?: Record<string, unknown>;
  editErrors?: {
    tripInformation: Record<string, string>;
    [policyNumber: string]: Record<string, string>;
  };
  editChanges?: {
    tripInformation: Record<string, string>;
    [policyNumber: string]: Record<string, string>;
    riders: Record<string, string>;
  };
  initialValues?: {
    tripInformation: Record<string, string>;
    [policyNumber: string]: Record<string, string>;
    riders: Record<string, string>;
  };
  dependentsInitials?: Array<Dependent>;
  dependentsErrors?: Array<Record<string, string>>;
  dependentsChanges?: Array<Dependent>;
  dependentDelta?: {
    added?: Dependent[];
    removed?: Dependent[];
    changed?: Dependent[];
    hasError?: boolean;
    hasChanges?: boolean;
  };
  activeAccordion?: number;
}
